import { environment } from './environments/environment';

import { enableProdMode, provideAppInitializer, inject, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { EnvService } from './app/services/env.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HttpreqInterceptor } from './app/services/httpreq.interceptor';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppComponent } from './app/app.component';

function appInit(env: EnvService) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (): Promise<any> =>
    env.loadExternalConfig(); 
}



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, OAuthModule.forRoot(), ReactiveFormsModule),
        provideAppInitializer(() => {
            const initializerFn = (appInit)(inject(EnvService));
            return initializerFn();
        }),
        { provide: HTTP_INTERCEPTORS, useClass: HttpreqInterceptor, multi: true },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));

 